export const enum ETaskTableContext {
  TASKS_PAGE = 'tasksPage',
  PROJECTS_PAGE = 'projectsPage'
}
